import Axios from "axios";

export class HistorialService {

    getHistorial(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/historial/lista?${queryParams}`).then(res => res.data);
    }
}